import { Button, Card, Col, Collapse, Flex, Form, Input, Row, Select, Table, Tag } from "antd";
import { useNavigate } from "react-router-dom";
import {SearchOutlined} from '@ant-design/icons';
import moment from "moment";
import { useEffect, useState } from "react";
import { ProjectInfoInterface } from "../../model/IprojectInfo";
import { CommitteeList } from "../../model/CommitteeList";
import { motion, AnimatePresence } from 'framer-motion';


import axios from "axios";

export function RequestListView(){
    const navigate = useNavigate();
    const [form] = Form.useForm()

    const [getData,setGetData] = useState<ProjectInfoInterface[]>([]);
    const [getShowData,setGetShowData] = useState<ProjectInfoInterface[]>([]);
    const [EditFilter,setEditfilter] = useState(false);
    const [CheckFilter,setCheckfilter] = useState(false);
    const [ReviewFilter,setReviewfilter] = useState(false);
    const [FinishedFilter,setFinishedfilter] = useState(false);


    const [CommitteeList,setCommitteeList] = useState<CommitteeList[]>([])

    
    function nextPage(ID:any,head_ID:any){
        console.log(ID)
        console.log(head_ID)
        sessionStorage.setItem('Order_ID', ID);
        sessionStorage.setItem('head_ID', head_ID);
        navigate(`/VU_HREC/PresProjectInfo`)
    }

    function resetSearch(){
        axios.get(`${process.env.REACT_APP_BASE}/GetDataForStaff`).then(response=>{
            if(response.status==200){
                setGetData(response.data)
                setGetShowData(response.data)
            }
        })
    }

    async function ProjectSearch(){
        const SearchData = form.getFieldsValue();
        const SearchedFilter ={
            ProjectNameTH:SearchData.ProjectNameTH,
            ProjectNameEN:SearchData.ProjectNameEN,
            ResearcherTHName:SearchData.ResearcherTHName,
            ResearcherENName:SearchData.ResearcherENName,
            ResearcherStatus:SearchData.ResearcherStatus,
            ResearcherPosition:SearchData.ResearcherPosition,
            ResearcherFac:SearchData.ResearcherFac,
        }

        console.log(SearchData)
        await axios.post(`${process.env.REACT_APP_BASE}/SearchForPresident`,SearchedFilter).then((response)=>{
            if(response.status==200){
                console.log('searchinch')
                console.log(response.data)
                setGetData(response.data);
                setGetShowData(response.data);
            }
        })
    }

    useEffect(()=>{
        resetSearch();
    },[])

    return(<>
    <h1>รายชื่อโครงการที่ยื่นขอพิจารณาจริยธรรมการวิจัยในมนุษย์</h1>
    <hr/>
        <Card>
              <h3><u>ฟอร์มค้นหาคำขอในระบบ</u></h3>
              <Form
                form={form}>
                <Row>
                    <Col span={11}>
                        <Form.Item name='ProjectNameTH' label='ชื่อโครงการที่ถูกยื่น'>
                            <Input placeholder='ชื่อโครงการที่ถูกยื่นภาษาไทย' />
                        </Form.Item>
                        <Form.Item name='ResearcherTHName' label='ชื่อของผู้ยื่นคำขอ'>
                            <Input placeholder='ชื่อผู้ยื่นภาษาไทย' />
                        </Form.Item>
                        <Form.Item name='ResearcherStatus' label='ประเภทผู้ยื่น'>
                            <Select placeholder='ex: ภายใน/ภายนอก'
                                options={[
                                    {value:1,label:'ภายใน'},
                                    {value:0,label:'ภายนอก'}
                                ]}/>
                        </Form.Item>
                        <Form.Item name='ResearcherFac' label='สังกัด' >
                            <Select placeholder='เลือกสังกัดที่มีการยื่นในระบบ'/>
                        </Form.Item>
                    </Col>
                    <Col span={2}>
                    </Col>
                    <Col span={11}>
                        <Form.Item name='ProjectNameEN' >
                            <Input placeholder='ชื่อโครงการภาษาอังกฤษ' />
                        </Form.Item>
                        <Form.Item name='ResearcherENName' >
                            <Input placeholder='ชื่อผู้ยื่นภาษาอังกฤษ' />
                        </Form.Item>
                        <Form.Item name='ResearcherPosition'>
                            <Select placeholder='ex: บุคลากร/นักศึกษา etc.'
                                options={[
                                    {value:'อาจารย์',label:'อาจารย์'},
                                    {value:'บุคลากร',label:'บุคลากร'},
                                    {value:'นักศึกษาระดับปริญญาตรี',label:'นักศึกษาระดับปริญญาตรี'},
                                    {value:'นักศึกษาระดับปริญญาโท',label:'นักศึกษาระดับปริญญาโท'},
                                    {value:'นักศึกษาระดับปริญญาเอก',label:'นักศึกษาระดับปริญญาเอก'},
                                    {value:'อื่นๆ',label:'อื่นๆ'}
                                ]} />
                        </Form.Item>
                      
                        
                    </Col>
                </Row>
                <Flex justify='flex-end'><Button type='primary' onClick={()=>resetSearch()} danger>รีเซ็ตการค้นหา</Button>&nbsp;<Button type='primary' onClick={()=>ProjectSearch()}>ค้นหา</Button></Flex>
              </Form>
        </Card>
            <br/>
            <hr/>
            <br/>
            <h3>ตัวกรองสถานะโครงการ</h3>
            <Row>
                <Col span={6}>
                    <Card onClick={()=>
                        {
                            setFinishedfilter(false)
                            setEditfilter(false)
                            setCheckfilter(false)
                            setReviewfilter(!ReviewFilter)
                            setGetShowData(getData.filter((item)=>(
                                item.project_status=='รอการตรวจสอบผลพิจารณา'||
                                item.project_status=='รอตรวจสอบจากประธานจริยธรรม'||
                                item.project_status=='รอตรวจสอบผลการแก้ไขจากประธาน'||
                                item.project_status=='ประธานฯแต่งตั้งกรรมการใหม่'||
                                item.project_status=='รอพิจารณากรรมการอีกครั้ง'
                                )))
                        }
                        } hoverable style={{marginLeft:5,marginRight:5,backgroundColor:'#943c78',color:'#fdfdfd',border:'none'}}>
                        <h2>รอตรวจสอบ</h2>
                        <Flex align='flex-start'  justify='center'>
                            <h1>
                                {getData.filter((item)=>(
                                    
                                    item.project_status=='รอตรวจสอบจากประธานจริยธรรม'||
                                    item.project_status=='ประธานฯแต่งตั้งกรรมการใหม่'||
                                    item.project_status=='รอการตรวจสอบผลพิจารณา'||
                                    item.project_status=='รอตรวจสอบผลการแก้ไขจากประธาน'||
                                    item.project_status=='รอพิจารณากรรมการอีกครั้ง'
                                    )).length}
                            </h1>
                        </Flex>
                    </Card>
                </Col>
                <Col span={6} >
                <Card onClick={()=>{
                    setReviewfilter(false)
                    setFinishedfilter(false)
                    setEditfilter(false)
                    setCheckfilter(!CheckFilter)
                    setGetShowData(getData.filter((item)=>(
                        item.project_status=='รอการพิจารณาจากกรรมการ'||
                        item.project_status == 'รอตรวจสอบจากเจ้าหน้าที่'||
                        item.project_status=='รอการตรวจสอบผลพิจารณา'||
                        item.project_status=='รอหนังสือรับรองจากหนังสือรับรองจากอธิการบดี'||
                        item.project_status=='รอพิจารณาผลการแก้ไขจากกรรมการ')
                    ))}} hoverable style={{marginLeft:5,marginRight:5,backgroundColor:'#6ba7fa',color:'#fdfdfd',border:'none'}}>
                    <h2>รอผลพิจารณา</h2>
                    <Flex align='flex-start'  justify='center'>
                        <h1>
                            {getData.filter((item)=>(
                               item.project_status=='รอการพิจารณาจากกรรมการ'||
                               item.project_status == 'รอตรวจสอบจากเจ้าหน้าที่'||
                               item.project_status=='รอการตรวจสอบผลพิจารณา'||
                               item.project_status=='รอหนังสือรับรองจากหนังสือรับรองจากอธิการบดี'||
                               item.project_status=='รอพิจารณาผลการแก้ไขจากกรรมการ'
                                )).length}
                        </h1>
                    </Flex>
                </Card>
            </Col>
                <Col span={6}>
                    <Card onClick={()=>{
                        setCheckfilter(false)
                        setReviewfilter(false)
                        setFinishedfilter(false)
                        setEditfilter(!EditFilter)
                        setGetShowData(getData.filter((item)=>(
                            item.project_status == 'แก้ไข'||
                            item.project_status=='แก้ไขข้อมูลตามผลพิจารณา')
                        ))
                    }} hoverable style={{marginLeft:5,marginRight:5,backgroundColor:'#ffc300',color:'#fdfdfd',border:'none'}}>
                        <h2>รอแก้ไข</h2>
                        <Flex align='flex-start'  justify='center'>
                            <h1>
                                {getData.filter((item)=>(
                                item.project_status=='แก้ไข'||
                                item.project_status=='แก้ไขข้อมูลตามผลพิจารณา')).length}
                            </h1>
                        </Flex>
                    </Card>
                </Col>
           
            
            <Col span={6}>
                <Card onClick={()=>{
                    {
                        setReviewfilter(false)
                        setEditfilter(false)
                        setCheckfilter(false)
                        setFinishedfilter(!FinishedFilter)
                        setGetShowData(getData.filter((item)=>(
                            item.project_status=='ไม่อนุมัติ'||
                            item.project_status=='ได้รับหนังสือรับรองจากอธิการบดี'
                            )))
                    }
                }} hoverable style={{marginLeft:5,marginRight:5,backgroundColor:'#95bf44',color:'#fdfdfd',border:'none'}}>
                    <h2>อนุมัติ/ไม่อนุมัติ</h2>
                    <Flex align='flex-start'  justify='center'>
                        <h1>
                            {getData.filter((item)=>(
                                item.project_status=='ไม่อนุมัติ'||
                                item.project_status=='ได้รับหนังสือรับรองจากอธิการบดี'
                                )).length}
                        </h1>
                    </Flex>
                </Card>
            </Col>
        </Row>
            <br/>
            {EditFilter&&
            <AnimatePresence>
                <motion.div 
                    initial={{ opacity: 0, y: -20, scale: 0.9 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={{ opacity: 0, y: -20, scale: 0.9 }}
                    transition={{ duration: 0.7, ease: [0.25, 0.8, 0.25, 1] }}>
                    <Flex style={{marginLeft:10}}>
                        <a onClick={()=>setGetShowData(getData.filter((item)=>item.project_status == 'แก้ไข'))}>
                            <Tag color='#FFE100' >แก้ไข</Tag></a>
                        <a onClick={()=>setGetShowData(getData.filter((item)=>(
                        item.project_status == 'แก้ไขข้อมูลตามผลพิจารณา'
                       )
                    ))}><Tag color='gold-inverse'>แก้ไขข้อมูลตามผลพิจารณา</Tag></a>
                    </Flex>
                </motion.div>
            </AnimatePresence>
        }

        {CheckFilter&&
            <AnimatePresence>
                <motion.div 
                    initial={{ opacity: 0, y: -20, scale: 0.9 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={{ opacity: 0, y: -20, scale: 0.9 }}
                    transition={{ duration: 0.7, ease: [0.25, 0.8, 0.25, 1] }}>
                    <Flex style={{marginLeft:10}}>
                        <a onClick={()=>setGetShowData(getData.filter((item)=>item.project_status=='รอการพิจารณาจากกรรมการ'))}>
                        <Tag color="#1C6EA4">รอการพิจารณาจากกรรมการ</Tag></a>
                        <a onClick={()=>setGetShowData(getData.filter((item)=>item.project_status=='รอตรวจสอบจากเจ้าหน้าที่'))}>
                            <Tag color="#33A1E0" >รอตรวจสอบจากเจ้าหน้าที่</Tag></a>
                        
                        <a onClick={()=>setGetShowData(getData.filter((item)=>item.project_status=='รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'))}>
                            <Tag color='#154D71'>รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่</Tag></a>
                        <a onClick={()=>setGetShowData(getData.filter((item)=>item.project_status=='รอหนังสือรับรองจากหนังสือรับรองจากอธิการบดี'))}>
                            <Tag color='#0e3c59'>รอหนังสือรับรองจากหนังสือรับรองจากอธิการบดี</Tag></a>
                    </Flex>
                </motion.div>
            </AnimatePresence>
        }

        {ReviewFilter&&
            <AnimatePresence>
                <motion.div 
                    initial={{ opacity: 0, y: -20, scale: 0.9 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={{ opacity: 0, y: -20, scale: 0.9 }}
                    transition={{ duration: 0.7, ease: [0.25, 0.8, 0.25, 1] }}>
                    <Flex style={{marginLeft:10}}>
                        <a onClick={()=>setGetShowData(getData.filter((item)=>item.project_status=='รอการตรวจสอบผลพิจารณา'))}>
                        <Tag color='#FFDFEF'  style={{ color: "#d63384" }}>รอการตรวจสอบผลพิจารณา</Tag></a>
                       
                        <a onClick={()=>setGetShowData(getData.filter((item)=>item.project_status=='รอตรวจสอบจากประธานจริยธรรม'))}>
                            <Tag color='#EABDE6' style={{ color: "#AA60C8" }}>รอตรวจสอบจากประธานจริยธรรม</Tag></a>
                        <a onClick={()=>setGetShowData(getData.filter((item)=>item.project_status=='ประธานฯแต่งตั้งกรรมการใหม่'))}>
                            <Tag color="#D69ADE" >ประธานฯแต่งตั้งกรรมการใหม่</Tag></a>
                            <a onClick={()=>setGetShowData(getData.filter((item)=>item.project_status=='รอตรวจสอบผลการแก้ไขจากประธาน'))}>
                            <Tag color='#EABDE6' style={{ color: "#AA60C8" }}>รอตรวจสอบผลการแก้ไขจากประธาน</Tag></a>
                        <a onClick={()=>setGetShowData(getData.filter((item)=>item.project_status=='รอพิจารณากรรมการอีกครั้ง'))}>
                            <Tag color='#AA60C8' >รอพิจารณากรรมการอีกครั้ง</Tag></a>
                    </Flex>
                </motion.div>
            </AnimatePresence>
        }

        {FinishedFilter&&
            <AnimatePresence>
                <motion.div 
                    initial={{ opacity: 0, y: -20, scale: 0.9 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={{ opacity: 0, y: -20, scale: 0.9 }}
                    transition={{ duration: 0.7, ease: [0.25, 0.8, 0.25, 1] }}>
                    <Flex style={{marginLeft:10}}>
                        <a onClick={()=>setGetShowData(getData.filter((item)=>item.project_status=='ไม่อนุมัติ'))}>
                            <Tag color="#FB4141" >ไม่อนุมัติ</Tag></a>
                        <a onClick={()=>setGetShowData(getData.filter((item)=>item.project_status=='ได้รับหนังสือรับรองจากอธิการบดี'))}>
                            <Tag color='#B4E50D'>ได้รับหนังสือรับรองจากอธิการบดี</Tag></a>
                    </Flex>
                </motion.div>
            </AnimatePresence>
        }
            <br/>
            <Table columns={[
                {
                    title:'',
                    dataIndex:'action',
                    key:'action',
                    width:'5vw',
                    render:(__, record)=><>
                <Button onClick={()=>{nextPage(record.Order_ID,record.head_ID)}}><SearchOutlined/></Button>
                    </>
                },
                {
                    title:'รหัสเอกสาร',
                    dataIndex:'projectID',
                    render:(__, record)=><>
                        <p>มว.จ. {record.projectID}</p>
                    </>

                },
                {
                    title:'ชื่อโครงการ',
                    dataIndex:'project_nameTH',
                    width:'30vw',
                    render:(__, record)=><>
                        <p>{record.project_nameTH}</p>
                        <p>{record.project_nameEN}</p>
                    </>

                },{
                    title:'ชื่อ-สกุลผู้ที่ยื่นคำขอ',
                    dataIndex:'researcher_THname',
                    width:'30vw',
                    render:(__, record)=><>
                        <p>{record.researcher_THname}</p>
                        <p>{record.researcher_ENname}</p>
                    </>
                },
                {
                    title:'สังกัดที่อยู่',
                    dataIndex:'researcher_facility',
                    width:'30vw',
                },
                {
                    title:'สถานะ',
                    dataIndex:'project_status',
                    render: (__: any, record: any) => {
                    let color = 'white';
                    switch (record.project_status) {
                        case 'แก้ไข':
                        case 'แก้ไขข้อมูลตามผลพิจารณา':
                          color = 'yellow';
                          break;
                      
                        case 'รอตรวจสอบจากประธานจริยธรรม':
                        case 'รอตรวจสอบผลการแก้ไขจากประธาน':
                        case 'ประธานฯแต่งตั้งกรรมการใหม่':
                          color = 'blue';
                          break;
                      
                        case 'รอการตรวจสอบผลพิจารณา':
                        case 'รอตรวจสอบจากเจ้าหน้าที่':
                        case 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่':
                        case 'รอพิจารณาผลการแก้ไขจากกรรมการ':
                          color = 'purple';
                          break;
                      
                        case 'รอการรับรองจากอธิการบดี':
                          color = 'lime';
                          break;
                      
                        case 'ได้รับหนังสือรับรองจากอธิการบดี':
                          color = 'green';
                          break;
                      
                        case 'ไม่อนุมัติ':
                          color = 'red';
                          break;
                      
                        default:
                          color = 'purple';
                          break;
                      }
                    return <Tag color={color}>{record.project_status}</Tag>;
                    },
                },{
                    title:'วันที่ยื่นเข้ามาล่าสุด',
                    dataIndex:'last_submitted',
                    sorter: (a, b) => {
                        const timeA = a.last_submitted ? moment(a.last_submitted).unix() : 0;
                        const timeB = b.last_submitted ? moment(b.last_submitted).unix() : 0;
                        return timeA - timeB;
                      },
                    render:(__, record)=><>
                    {moment(record.last_submitted).format('DD/MM/YY HH:mm:ss')}
                    </>
                },{
                    title:'วันสิ้นสุดการพิจารณา',
                    dataIndex:'review_in',
                    render: (_, record) => {
                        const isOverdue = record?.review_in && moment(record.review_in).isBefore(moment(), 'day');
                        return record?.review_in ? (
                          <p style={{ color: (isOverdue&&record?.project_status=='รอการพิจารณาจากกรรมการ') ? 'red' : 'black' }}>
                            {moment(record.review_in).format('DD/MM/YY')}
                          </p>
                        ) : (
                          <>-</>
                        );
                      }
                },{
                    title:'วันสิ้นสุดการแก้ไข',
                    dataIndex:'edit_in',
                    render: (_, record) => {
                        const isOverdue = record?.edit_in && moment(record.edit_in).isBefore(moment(), 'day');
                        return record?.edit_in ? (
                          <p style={{ color: isOverdue ? 'red' : 'black' }}>
                            {moment(record.edit_in).format('DD/MM/YY')}
                          </p>
                        ) : (
                          <>-</>
                        );
                      }
                },
            ]}
            dataSource={getShowData}
            />
    </>)
}